import React from "react";
import { useTranslation } from "react-i18next";
import { S3_BASE_URL } from "../../utils/Constants";

const ScheduleDetailModal = ({
  selectedSchedule,
  setSelectedSchedule,
  statusConfig,
  formatTimeRange,
}) => {
  const { t } = useTranslation();

  if (!selectedSchedule) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-xl font-bold text-gray-900">
              {t("scheduleDetails", "Schedule Details")}
            </h2>
            <button
              onClick={() => setSelectedSchedule(null)}
              className="text-gray-400 hover:text-gray-600 text-2xl leading-none"
            >
              ✕
            </button>
          </div>

          {/* Detail content */}
          <div className="space-y-4">
            <div>
              <h3 className="font-medium text-gray-900 mb-2">
                {t("subscriptionInfo", "Subscription Information")}
              </h3>
              <div className="bg-gray-50 rounded-lg p-3 space-y-2 text-sm">
                <p>
                  <span className="font-medium">{t("name", "Name")}:</span>{" "}
                  {selectedSchedule.subscriptionName}
                </p>
                <p>
                  <span className="font-medium">
                    {t("servingDate", "Serving Date")}:
                  </span>{" "}
                  {selectedSchedule.servingDate}
                </p>
                <p>
                  <span className="font-medium">
                    {t("timeSlot", "Time Slot")}:
                  </span>{" "}
                  {formatTimeRange(
                    selectedSchedule.timeToServeFrom,
                    selectedSchedule.timeToServeTo
                  )}
                </p>
                <p>
                  <span className="font-medium">{t("status.title", "Status")}:</span>{" "}
                  {statusConfig[selectedSchedule.status]?.label}
                </p>
              </div>
            </div>

            {/* Additional details can be added here */}
            {selectedSchedule.meals && selectedSchedule.meals.length > 0 && (
              <div>
                <h3 className="font-medium text-gray-900 mb-2">
                  {t("meals", "Meals")} ({selectedSchedule.meals.length})
                </h3>
                <div className="bg-gray-50 rounded-lg p-3">
                  <div className="space-y-2">
                    {selectedSchedule.meals.map((meal, index) => (
                      <div
                        key={index}
                        className="flex items-center gap-3 p-2 bg-white rounded"
                      >
                        {meal.imageUrl && (
                          <img
                            src={S3_BASE_URL + "/" + meal.imageUrl}
                            alt={meal.name}
                            className="w-10 h-10 rounded object-cover"
                          />
                        )}
                        <div className="flex-1">
                          <p className="font-medium text-sm">{meal.name}</p>
                          {meal.description && (
                            <p className="text-xs text-gray-600">
                              {meal.description}
                            </p>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}

            {selectedSchedule.location && (
              <div>
                <h3 className="font-medium text-gray-900 mb-2">
                  {t("deliveryLocation", "Delivery Location")}
                </h3>
                <div className="bg-gray-50 rounded-lg p-3 text-sm space-y-1">
                  <p className="font-medium">
                    {selectedSchedule.location.name}
                  </p>
                  {selectedSchedule.location.buildingName && (
                    <p>{selectedSchedule.location.buildingName}</p>
                  )}
                  {selectedSchedule.location.buildingNumber && (
                    <p>
                      {t("building", "Building")}:{" "}
                      {selectedSchedule.location.buildingNumber}
                    </p>
                  )}
                  {selectedSchedule.location.apartmentNumber && (
                    <p>
                      {t("apartment", "Apartment")}:{" "}
                      {selectedSchedule.location.apartmentNumber}
                    </p>
                  )}
                  {selectedSchedule.location.phoneNumber && (
                    <p>
                      {t("phone", "Phone")}:{" "}
                      {selectedSchedule.location.phoneNumber}
                    </p>
                  )}
                  {selectedSchedule.location.note && (
                    <p className="italic text-gray-600">
                      {selectedSchedule.location.note}
                    </p>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScheduleDetailModal;
